// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1f6Br","inlineContainer":"style_inlineContainer__1Y5z1","link":"style_link__1gKt1"};